<template>
  <div id="user-edit-account-details">
    <div class="vx-row">
      <div class="vx-col w-full">
        <h5>Role Details</h5>
      </div>
    </div>

    <div class="vx-row my-4">
      <div class="vx-col w-1/2">
        <h5>{{ data_local.RoleName }}</h5>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <label class="vs-input--label font-bold">Description</label>
        <p>{{ data_local.RoleDescription }}</p>
      </div>
    </div>
    <div class="vx-row mt-4">
      <div class="vx-col w-1/2">
        <label class="vs-input--label font-bold">Application</label>
        <div class="mt-1">
        <router-link
            class="underline text-black"
            v-if="application"
            :to="{name: 'application.view', params: { id: application.Application_PK }}">{{
            application.ApplicationName
          }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
    }
  },
  computed: {
    application() {
        return this.data.applications.length ? this.data.applications[0] : null;
    },
    id() {
      return this.data.id;
    }
  },
}
</script>
